const {Solar, Lunar, Foto, Tao, NineStar, EightChar, SolarWeek, SolarMonth, SolarSeason, SolarHalfYear, SolarYear, LunarMonth, LunarYear, LunarTime, ShouXingUtil, SolarUtil, LunarUtil, FotoUtil, TaoUtil, HolidayUtil, NineStarUtil, I18n} = require('./lunar.js')

module.exports = {
  Solar: Solar,
  Lunar: Lunar,
  Foto: Foto,
  Tao: Tao,
  NineStar: NineStar,
  EightChar: EightChar,
  SolarWeek: SolarWeek,
  SolarMonth: SolarMonth,
  SolarSeason: SolarSeason,
  SolarHalfYear: SolarHalfYear,
  SolarYear: SolarYear,
  LunarMonth: LunarMonth,
  LunarYear: LunarYear,
  LunarTime: LunarTime,
  ShouXingUtil: ShouXingUtil,
  SolarUtil: SolarUtil,
  LunarUtil: LunarUtil,
  FotoUtil: FotoUtil,
  TaoUtil: TaoUtil,
  HolidayUtil: HolidayUtil,
  NineStarUtil: NineStarUtil,
  I18n: I18n
}
